interface HtmlConfig {
  GOOGLE_ANALYTICS_ID: string;
  SENTRY_URL: string;
}

interface Config {
  hasGA: boolean;
  hasSentry: boolean;
  GoogleAnalyticsId: string;
  SentryUrl: string;
}

declare global {
  interface Window {
    __env__: HtmlConfig;
  }
}

export function getConfig(): Config {
  const hasGA = !!process.env.REACT_APP_GOOGLE_ANALYTICS_ID && process.env.REACT_APP_GOOGLE_ANALYTICS_ID !== 'NO_GA';
  const hasSentry = !!window.__env__.SENTRY_URL && window.__env__.SENTRY_URL !== 'NO_SENTRY';
  return {
    hasGA,
    hasSentry,
    GoogleAnalyticsId: hasGA ? process.env.REACT_APP_GOOGLE_ANALYTICS_ID : '',
    SentryUrl: hasSentry ? window.__env__.SENTRY_URL : '',
  };
}
